<app-menu [menuModuleEnum]="menuModuleEnum" [isRenderMenu]="false"></app-menu>

<div class="container-body">
  <div class="white-body">
    <div class="title-header">
      <mat-icon aria-hidden="false" aria-label="devices">devices</mat-icon>
      <h1>Gerenciar dispositivos conectados</h1>
    </div>


    @if (listAutomaticLogin != undefined && listAutomaticLogin.length > 0 && !this.isLoading) {
      <p class="info-body">Clique em um dispositivo para desconectá-lo:</p>
    }
    @if (listAutomaticLogin != null && !this.isLoading) {
      <div class="card-list">
        <div class="row">
          @for (item of listAutomaticLogin; track item) {
            <div class="col-12 col-sm-6 col-md-4">
              <div class="card-item">
                <div class="icon-device">
                  @if (!item.automaticLogin.isMobile) {
                    <mat-icon aria-hidden="false" aria-label="devices">laptop</mat-icon>
                  }
                  @if (item.automaticLogin.isMobile) {
                    <mat-icon aria-hidden="false" aria-label="devices">smartphone</mat-icon>
                  }
                </div>
                <div class="infos">
                  <span class="primary">{{item.automaticLogin.browser}} ({{item.automaticLogin.device}})</span>
                  <span class="secundary-status last-info">Última sessão ativa: {{item.lastSession}}</span>
                  <div class="button-desconect col-6">
                    <button mat-flat-button color="accent" class="btn-block" (click)="desconect(item)">
                      Desconectar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (listAutomaticLogin != undefined && listAutomaticLogin.length == 0 && !this.isLoading) {
      <app-empty-list></app-empty-list>
    }

    @if (isLoading) {
      <app-loading-list></app-loading-list>
    }

    <div class="button-conclude row">
      <div class="col-12 col-md-4">
        <button mat-flat-button color="accent" class="btn-block" (click)="goBack()">
          @if (isLoading == false) {
            <span>Sair</span>
          }
          @if (isLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
      </div>
    </div>
  </div>
</div>